import { Popover } from 'antd';
import React from 'react';
import { IconProps } from 'react-feather';
import { ImFileText2 } from 'react-icons/im';
import { Link } from 'react-router-dom';

interface Props extends IconProps {
  redirect?: string;
  disabled?: boolean;
  popover?: string;
}

const ReceiptIcon: React.FC<Props> = ({
  redirect,
  disabled,
  popover,
  ...props
}) => {
  const icon = (
    <ImFileText2
      size={20}
      cursor="pointer"
      {...props}
      onClick={!disabled ? props?.onClick : undefined}
      style={{
        cursor: disabled ? 'not-allowed' : undefined,
        color: disabled ? 'darkgray' : undefined,
        pointerEvents: disabled ? 'none' : undefined,
      }}
    />
  );

  return (
    <Popover content={popover || 'Recibo'}>
      {redirect ? (
        <span
          style={{
            cursor: disabled ? 'not-allowed' : undefined,
          }}
        >
          <Link
            to={redirect}
            style={{
              pointerEvents: disabled ? 'none' : undefined,
            }}
          >
            {icon}
          </Link>
        </span>
      ) : (
        icon
      )}
    </Popover>
  );
};

export default ReceiptIcon;
